import { Box } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
export const EntityWrapper = styled(Box)({
  width: "100%",
});

export const Footer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  padding: "0.6rem",
  backgroundColor: alpha(theme.palette.grey.A100, 0.5),
  ...(theme.palette.mode === "dark" && {
    backgroundColor: alpha(theme.palette.common.white, 0.06),
  }),

  [theme.breakpoints.down(910)]: {
    fontSize: "0.65rem",
    "& .MuiTypography-root": {
      fontSize: "0.65rem",
    },
  },
}));
